<template>
    <div class="columns">
        <div class="column is-half">
            <b-field label="Atributo">
                <b-input
                type="text"
                v-model="data.title"
                value=""
                maxlength="60">
                </b-input>
            </b-field>
        </div>
        <div class="column is-half">
            <b-field label="Valores">
            </b-field>
            <b-field class="p-0 m-0">
                <b-taginput
                    v-model="data.values"
                    class="p-0 m-0"
                    ellipsis
                    placeholder="Agregar valor">
                </b-taginput>
                <p class="control">
                    <a class="m-l-10 " @click="deleteAttribute">
                        <b-icon size="is-small" class="has-text-danger" icon="times-circle" ></b-icon>
                    </a>
                </p>
            </b-field>
        </div>
    </div>
</template>


<script>
export default {
    props:{
        data:{
            type:Object,
            default: new Object({})
        },
        index:{
            type:String,
            default:""
        }
    },
    methods:{
        deleteAttribute(){
            this.$emit("deleteAttribute")
        }
    }
}
</script>
